// Gedeelde lijst van farmaceutische (toedienings)vormen.
// Gebruikt door SlidesManager (profiel-editor) en KoppelingenTab (handmatig koppelen).
// Stemt overeen met resolve_vorm() in backend/vormen.py.
export const VORM_OPTIES = [
  "tablet", "tablet (verlengde afgifte)", "maagsapresistente tablet", "dispergeerbare tablet",
  "bruistablet", "kauwtablet", "oplosbare tablet", "capsule", "capsule (verlengde afgifte)",
  "kauwcapsule", "granulaat", "bruisgranulaat", "lyofilisaat", "siroop", "suspensie", "drank",
  "druppels", "injectie", "infusie", "inhalatiepoeder", "inhalatieoplossing",
  "inhalatiespray", "verneveloplossing", "nasaal", "neusspray", "auriculair",
  "oogpreparaat", "oogdruppels", "oogzalf", "zetpil", "rectaal schuim", "ovule",
  "crème", "gel", "zalf", "lotion", "shampoo", "transdermaal verband", "implantaat",
];
